import { createAsyncThunk } from "@reduxjs/toolkit";
import CAxios from "../utils/CAxios";
import axios, { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";

/*--------------------------GET SponsorShip Cancel -------------------------------------------*/
export const getSponsorshipCancel = createAsyncThunk<
  any,
  {
    sponsor_id: number;
    limit?: number;
    page?: number;
    cancel_reason_id?: number;
    date_from?: string;
    date_to?: string;
  }
>("sponsor/getSponsorshipCancel", async (data) => {
  try {
    const response = await CAxios.post(`sponsor/sponsorship/cancel`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
/*--------------------------GET Cancel Reasons -------------------------------------------*/
export const getCancelReasons = createAsyncThunk<AxiosResponse<any, any>>(
  "sponsor/getCancelReasons",
  async () => {
    try {
      let response = await axios.get(`${baseUrlApi}sponsorship/cancel/reasons`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
/*--------------------------Cancel Sponsorship -------------------------------------------*/
export const cancelSponsorship = createAsyncThunk<AxiosResponse<any, any>, any>(
  "sponsor/cancelSponsorship",
  async (data) => {
    try {
      let response = await CAxios.post(`sponsorship/cancel`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
